import React, { useEffect, useCallback, useState, useRef } from 'react';
import classnames from 'classnames';
import { useAction } from '@wix/da-hooks/pkg/useAction';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import { getCommentableTypeForDeviationType } from '../../redux/helpers';
import CommentBox from '../../../CommentBox/presets/CommentBox';
import { focusEditor } from '../../../CommentEditor/redux/actionCreators';
import { focusEditor as focusEditorNew } from '../../../CommentEditor.editor_v3/redux/actionCreators';
import { deviationThreadUpdated } from '../../../CommentThread/actionCreators';
import s from './CommentBoxPanel.scss';
const CommentBoxPanel = ({ deviation, onClose, panelOpenEvent, panelCloseEvent })=>{
    const isEditorCommentFlagEnabled = useFlag('editor_comment');
    const onThreadUpdated = useAction(deviationThreadUpdated);
    const dispatchFocusEditor = useAction(focusEditor);
    const dispatchFocusEditorNew = useAction(focusEditorNew);
    const rootRef = useRef(null);
    const [isOpen, setIsOpen] = useState(false);
    const editorId = `commentpanel-${deviation.deviationId}`;
    const onPanelOpen = useCallback(()=>{
        isEditorCommentFlagEnabled ? dispatchFocusEditorNew(editorId) : dispatchFocusEditor(editorId);
    }, [
        editorId,
        dispatchFocusEditor,
        dispatchFocusEditorNew,
        isEditorCommentFlagEnabled
    ]);
    useEffect(()=>{
        panelOpenEvent.addListener(onPanelOpen, true);
        /*
      A transitionend handler is put on the PanelPopup parent that uses scrollTo to follow along
      with any animations that it or it's children have, I guess? Uncertain of the original purpose.

      But we don't want that for our animation here, so stop propagation.
    */ rootRef.current && rootRef.current.addEventListener('transitionend', (e)=>e.stopPropagation());
        return ()=>{
            panelOpenEvent.removeListener(onPanelOpen);
        };
    }, [
        onPanelOpen,
        panelOpenEvent,
        rootRef
    ]);
    const onPublishSuccess = useCallback((result)=>{
        // we wait for the panel animation's finish before the scroll,
        // otherwise it's a really janky effect
        panelCloseEvent.addListener(()=>{
            onThreadUpdated(deviation, result);
        }, true);
        onClose();
    }, [
        panelCloseEvent,
        onThreadUpdated,
        deviation,
        onClose
    ]);
    const handleEditorReady = useCallback(()=>{
        setIsOpen(true);
    }, []);
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], isOpen && s['open']),
        ref: rootRef
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['wrapper']
    }, /*#__PURE__*/ React.createElement(CommentBox, {
        id: editorId,
        commentableType: getCommentableTypeForDeviationType(deviation),
        commentableItemId: deviation.deviationId,
        onPublishSuccess: onPublishSuccess,
        onEditorReady: handleEditorReady,
        onClose: onClose,
        className: s['comment-box'],
        footerClassName: s['comment-box-footer']
    })));
};
CommentBoxPanel.displayName = 'CommentBoxPanel';
export default CommentBoxPanel;

//# sourceMappingURL=CommentBoxPanel.js.map